<template>
    <div class="app-container">
        <b-loading :active="loading"></b-loading>

        <header class="navbar is-fixed-top is-primary">
            <div class="container-navbar">
                <div class="navbar-brand">
                    <router-link :to="{name: 'home'}" class="navbar-item">
                        <img v-if="appinfo('logo')" :src="appinfo('logo.url')" width="140" height="30"
                             :alt="appinfo('name')">
                        <span v-else v-text="appinfo('name')"></span>
                    </router-link>
                </div>
                <nav class="navbar-menu is-active">
                    <div class="navbar-end">

                        <div class="navbar-item has-dropdown is-hoverable">
                            <span class="navbar-link has-text-weight-bold" v-text="user.name"></span>
                            <div class="navbar-dropdown is-boxed">
                                <a href="#" class="navbar-item" @click.prevent="logout"
                                   v-text="__('strings.auth.menu.logout')"></a>
                                <router-link :to="{ name: 'user.change-password' }" class="navbar-item"
                                             v-text="__('strings.auth.menu.edit-password')"></router-link>
                            </div>
                        </div>
                        <div v-if="notifications.length" class="navbar-item has-dropdown is-hoverable">
                            <span class="navbar-link has-text-weight-bold">
                                <b-icon icon="bell"></b-icon>
                                <span class="num-notice" v-text="notifications.length"></span>
                            </span>
                            <div class="navbar-dropdown is-boxed is-right" style="width: 400px">
                                <div class="list-notices">
                                    <div v-for="(notice, index) in notifications" class="notice-item"
                                         :class="notice.type">
                                        <b-icon v-if="notice.type === 'warning'" icon="alert"
                                                class="notice-icon"></b-icon>
                                        <b-icon v-if="notice.type === 'error'" icon="alert-circle"
                                                class="notice-icon"></b-icon>
                                        <b-icon v-if="notice.type === 'success'" icon="check-circle"
                                                class="notice-icon"></b-icon>
                                        <b-icon v-if="notice.type === 'info'" icon="information"
                                                class="notice-icon"></b-icon>

                                        <div class="notice-content">
                                            <router-link
                                                class="main-link"
                                                v-if="notice.hasAction"
                                                :to="{ name: 'model.action', params: {resource: notice.action.resource, action: notice.action.action} }"
                                                v-text="notice.message">
                                            </router-link>
                                            <span v-if="!notice.hasAction" v-html="notice.message"></span>
                                        </div>
                                        <div class="remove-action">
                                            <button v-if="notice.isDeleable" @click="removeNotice(notice)">
                                                <b-icon icon="close"></b-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>

        <div class="sidebar-bg">
            <main-sidebar :menu-items="menuItems" :sub-menu-items="subMenuItems"></main-sidebar>
        </div>
        <div id="app" class="container dashboard is-fluid">
            <custom-sidebar></custom-sidebar>
            <main class="main-content">
                <router-view :checkedRows.sync="checkedRows"></router-view>
            </main>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            user: {
                name: ''
            },
            menuItems: [],
            subMenuItems: new Map(),
            checkedRows: [],
            notifications: []
        }
    },
    mounted() {

        axios.get('/user')
            .then(response => {
                this.user = response.data
            })
        this.loadNotices();
        setInterval(()=>{
            this.loadNotices();
        },60000);

        axios.get('/menu')
            .then(response => {
                this.responseData = response.data;
                const keys = Object.keys(this.responseData);
                keys.forEach((key) => this.menuItems.push(this.responseData[key]));
                this.menuItems.forEach((menuItem, index) => {
                    if (menuItem?.items?.length > 0) {
                        menuItem.items.sort((x, y) => ((x?.dropdown?.is_active === y?.dropdown?.is_active) ? 0 : x ? 1 : -1))
                        this.subMenuItems.set(menuItem.name, menuItem.items);
                    }
                });
                this.loading = false
            })
    },

    methods: {
        loadNotices(){
            console.log("LOADNOTICES");
            axios.get('/notifications')
                .then(response => {
                    if (response.data && response.data.notices) {
                        const notifications = [];
                        for (const notice of response.data.notices) {
                            notice.hasAction = false;
                            notice.isDeleable = notice.id > 0;
                            if (notice.action) {
                                const actionPart = notice.action.split("/");
                                if (actionPart.length > 1) {
                                    notice.hasAction = true;
                                    notice.action = {
                                        action: actionPart[1],
                                        resource: actionPart[0]
                                    }
                                }
                            }
                            notifications.push(notice);
                        }
                        this.notifications = notifications;
                    }
                })
        },
        removeNotice(notice) {
            const notices = [];
            for(const n of this.notifications){
                if(n.id==notice.id){
                    continue;
                }
                notices.push(n);
            }
            this.notifications = notices;
            axios.delete("/notifications/"+notice.id);
        },
        logout() {
            axios.post('/logout')
                .then(response => {
                    this.$router.push({name: 'auth.login'})
                })
                .catch(error => {
                    // TODO (marco): manage eventual errors here
                })
        }
    }
}
</script>
